<template>

    <v-dialog v-model="show" persistent width="430" max-width="80%" :attach="$store.state.fullscreenElement" @keydown="(k) => {k.key == 'Escape' ? show = false : null}">
      <v-card>
        <v-card-title class="headline" style="color: #FB8C00;">
            <v-icon class="mr-3" color="#FB8C00">mdi-alert</v-icon>Unverified Paging Methods
        </v-card-title>

        <v-card-text>
            Your user account is currently configured with an unverified email address and/or sms number.<br><br>
            <span v-if="user.user_page_email">
                Email: <b>{{user.user_page_email}}</b>
                <span style="color: #FB8C00" v-if="$props.emailUnverified" v-text="' UNVERIFIED'" />
                <span style="color: #4caf50" v-if="!$props.emailUnverified" v-text="' VERIFIED'" />
            </span><br>
            <span v-if="user.user_page_smpp">
                SMS: <b>{{user.user_page_smpp}}</b>
                <span style="color: #FB8C00" v-if="$props.smsUnverified" v-text="' UNVERIFIED'" />
                <span style="color: #4caf50" v-if="!$props.smsUnverified" v-text="' VERIFIED'" />
            </span>
            <br><br>
            Rich Notifications will have limited funtionality until these are verified. Please go <span class="red-link" @click="goToVerify">here</span> to verify. <br><br>
            <v-icon>mdi-information</v-icon> <span class="white-link ml-1" @click="goToTutorials">Learn more about Rich Notifications</span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn text color="#FB8C00" @click.stop="show=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

</template>

<script>
export default {
    name: 'UnverifiedDialog',
    props: {
        value: Boolean,
        emailUnverified: Boolean,
        smsUnverified: Boolean
    },
    data: () => ({
        user: null
    }),

    computed: {
        show: {
            get () {
                return this.value
            },
            set (value) {
                this.$emit('input', value);
            }
        },
    },

    methods: {
        goToVerify: function() {
            this.show = false;
            this.$store.commit('setUserPageVerifyShortcut', true);
            this.$router.push('users');
        },

        goToTutorials: function() {
            this.show = false;
            this.$store.commit('setTutorialsShortcut', 'Rich Notifications');
            this.$router.push('tutorials');
        }
    },

    watch: {
    },

    created() {
        this.user = this.$store.state.user;
    },

    mounted() {
    },
  
};
</script>

<style scoped>

    .red-link {
        color: #c42111;
        font-weight: bold;
        text-decoration: underline;
        cursor: pointer;
        text-transform: uppercase;
    }

    .white-link {
        color: #ffffff;
        font-weight: bold;
        text-decoration: underline;
        cursor: pointer;
        vertical-align: middle;
    }

</style>

